import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this.checkDarkMode();
    this.watchDarkMode();
  }

  checkDarkMode() {
    if (this.darkModeQuery.matches) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }

  watchDarkMode() {
    this.darkModeQuery.addListener(() => {
      this.checkDarkMode();
    });
  }
}
